exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-1b92ec89]{color:#000}.pedidos a[data-v-1b92ec89]{text-decoration:none;cursor:pointer}.pedidos a .card[data-v-1b92ec89]:hover{box-shadow:2px 2px 6px 0 #a7a7a7}.card[data-v-1b92ec89]{height:100%;background-image:linear-gradient(180deg,transparent,transparent,rgba(0,0,0,.07));border:1px solid rgba(0,0,0,.2);border-radius:.8rem}.nav-pills .nav-link.active[data-v-1b92ec89],.nav-pills .show>.nav-link[data-v-1b92ec89]{color:var(--btntxt1);background-color:var(--btnbg1)}.alturadiv[data-v-1b92ec89]{height:22px}", ""]);

// exports
